import React, { useEffect, useState } from 'react';
import Layout from '../../elements/Layout';
import { getAccountsDueReports } from '../../utils/api/api';
import { Bar } from 'react-chartjs-2';
import Select from 'react-select';
import { CSVLink } from 'react-csv';
import { FiDownload } from 'react-icons/fi';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const periodOptions = [
    { value: 'today', label: 'Today' },
    { value: 'this_week', label: 'This Week' },
    { value: 'this_month', label: 'This Month' },
    { value: 'this_year', label: 'This Year' }
];

const AccountsDueReports = () => {
    const [reports, setReports] = useState(null);
    const [selectedPeriods, setSelectedPeriods] = useState(periodOptions);

    useEffect(() => {
        const fetchReports = async () => {
            try {
                const response = await getAccountsDueReports();
                setReports(response.accountsDue);
            } catch (error) {
                console.error('Error fetching accounts due report:', error);
            }
        };
        fetchReports();
    }, []);

    const chartData = reports && {
        labels: selectedPeriods.map(p => p.label),
        datasets: [
            {
                label: 'Amount Due (KES)',
                data: selectedPeriods.map(p => reports[p.value] || 0),
                backgroundColor: '#0A1929',
                borderColor: '#0A1929',
                borderWidth: 1,
            }
        ]
    };

    const exportData = selectedPeriods.map(p => ({
        period: p.label,
        amount: reports ? reports[p.value] || 0 : 0
    }));

    return (
        <Layout text="Accounts Due Reports">
            <div className="p-6 bg-white shadow rounded-lg">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-2xl font-semibold">Accounts Due</h2>
                    {reports && (
                        <CSVLink
                            data={exportData}
                            filename="accounts_due_reports.csv"
                            className="flex items-center gap-2 bg-primary text-[14px] text-white px-4 py-2 rounded-lg hover:shadow-md transition"
                        >
                            <FiDownload /> Export CSV
                        </CSVLink>
                    )}
                </div>

                <div className="mb-4">
                    <label className="font-medium">Select Period(s):</label>
                    <Select
                        options={periodOptions}
                        isMulti
                        value={selectedPeriods}
                        onChange={setSelectedPeriods}
                        className="mt-2"
                    />
                </div>

                {chartData ? (
                    <Bar
                        data={chartData}
                        options={{
                            responsive: true,
                            plugins: {
                                legend: { display: false },
                                title: {
                                    display: true,
                                    text: `Accounts Due (${selectedPeriods.map(p => p.label).join(', ')})`,
                                    font: { size: 18 },
                                },
                            },
                            scales: {
                                x: {
                                    title: { display: true, text: 'Time Period', font: { size: 14 } },
                                    grid: { display: false },
                                },
                                y: {
                                    title: { display: true, text: 'Amount (KES)', font: { size: 14 } },
                                    grid: { color: 'rgba(0, 0, 0, 0.1)' },
                                },
                            },
                        }}
                    />
                ) : (
                    <p className="text-center text-gray-500">Loading report data...</p>
                )}
            </div>
        </Layout>
    );
};

export default AccountsDueReports;
